import { colors } from '../../../../theme/color-palette';
import mediumPurpleRectangle from '../../../../assets/legends/mediumPurpleRectangle.svg';
import lightPurpleRectangle from '../../../../assets/legends/lightPurpleRectangle.svg';
import dashedRectangle from '../../../../assets/legends/dashedRectangle.svg';

const { FONT_COLOR, LIGHT_GRAY_HEX } = colors;

export const getToolTipFormat = () => {
	return `<div style="padding: 12px 16px; display: flex; flex-direction: column; gap: 16px; width: 260px ">  
                <div style="
                    font-size: 12px;
                    width: 280px;
                    text-align: left;
                    font-family: 'Bogle-Regular';
                    font-weight: 700; 
                    line-height: 16px;
                    color: ${FONT_COLOR}"
                >
                    Supplier Dollar Share
                </div>

                <div style="display: flex; flex-direction: column; gap: 12px;">
                    <div style="display: flex; align-items: flex-start; gap: 8px;"> 
                        <div style="display: flex;  align-items: center; height: 16px">
                            <img style="height: 10px; width: 10px " src =${mediumPurpleRectangle} />
                        </div>

                        <div style="display: flex; justify-content: space-between; align-items: flex-start; width: 100%" >
                            <div style="display: flex; flex-direction: column; gap: 4px;">
                                <span style="font-size: 12px; line-height: 16px; color: ${FONT_COLOR}">{currentWeek}</span>
                                <span style="font-size: 10px; line-height: 16px; color: ${LIGHT_GRAY_HEX}; ">{current_duration}</span>
                            </div>

                                <span style="font-size: 12px; line-height: 16px; color: ${FONT_COLOR}; font-weight: 700">{current_percentage_tooltip}%</span>
                        </div>
                    </div>

                    <div style="display: flex; align-items: flex-start; gap: 8px;"> 
                        <div style="display: flex;  align-items: center; height: 16px">
                            <img style="height: 10px; width: 10px " src =${lightPurpleRectangle} />
                        </div>

                        <div style="display: flex; justify-content: space-between; align-items: flex-start; width: 100%" >
                            <div style="display: flex; flex-direction: column; gap: 4px; align-items: flex-start">
                                <div style="display: flex; font-size: 12px; line-height: 16px; color: ${FONT_COLOR}">
                                <span style= "
                                    background-color:{bpsChgRefBackgroundColor}; 
                                    padding: 0px 4px 0px 4px; 
                                    border-radius: 5px; 
                                    font-size: 12px; 
                                    color: {bpsChgRefColor};
                                    font-weight: 700;
                                    display: flex;
                                    flex-direction: row;
                                    gap: 2px;
                                    line-height: 16px;
                                     align-items: center;
                                "> 
                                    <img style="padding: 2px 4px; height: 12px; width: 8px; " src={bpsChgRefArrow} />  
                                    {bps_change_ref} bps
                                </span>
                            <span style="font-size: 12px; margin-left: 5px; color: ${FONT_COLOR}">vs Previous Period</span>
                        </div>
                                <span  style="font-size: 10px; line-height: 16px; color: ${LIGHT_GRAY_HEX}; ">{previous_duration}</span>
                            </div>

                                <span style="font-size: 12px; line-height: 16px; color: ${FONT_COLOR}; font-weight: 700">{previous_percentage_tooltip}%</span>
                        </div>
                    </div>

                    <div style="display: flex; flex-direction: row; align-items: flex-start; gap: 5px;"> 
                        <div style="display: flex;  align-items: center; height: 16px;">
                            <img style="height: 100%; width: 68%; " src=${dashedRectangle} />
                        </div>

                        <div style="display: flex; justify-content: space-between; align-items: flex-start; width: 100%" >
                            <div style="display: flex; flex-direction: column; gap: 4px; align-items: flex-start">
                                <div style="display: flex; font-size: 12px; line-height: 16px; color: ${FONT_COLOR}">
                                    <span style= "
                                        background-color: {bpsChgLyBackgroundColor}; 
                                        padding: 0px 4px 0px 4px; 
                                        border-radius: 5px; 
                                        font-size: 12px; 
                                        color: {bpsChgLyColor};
                                        font-weight: 700;
                                        display: flex;
                                        flex-direction: row;
                                        gap: 2px;
                                        line-height: 16px;
                                        align-items: center;
                                    "> 
                                        <img style="padding: 2px 4px; height: 12px; width: 8px;" src={bpsChgLyArrow} /> 
                                        {bps_change_ly} bps
                                    </span>
                                    <span style="font-size: 12px; margin-left: 5px; color: ${FONT_COLOR}">vs Last Year</span>
                                </div>
                                <span style="font-size: 10px; line-height: 16px; color: ${LIGHT_GRAY_HEX}; ">{ly_current_duration}</span>
                            </div>
                                <span style="font-size: 12px; line-height: 16px; color: ${FONT_COLOR}; font-weight: 700">{ly_current_percentage_tooltip}%</span>
                        </div>
                    </div>
                </div>
            </div>`;
};
